import React from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';
import TreatmentSearch from '@client/feature/treatment/TreatmentSearch';

const root = document.getElementById('treatmentSearch');

/**
 * This app is responsible for the treatment search
 *
 * @returns {Element}
 * @constructor
 */
const TreatmentSearchApp = () => {
  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <TreatmentSearch />
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 */
ReactDOM.createRoot(root).render(<TreatmentSearchApp />);